import * as React from 'react';
import PropTypes from 'prop-types';
import Text from '../text';
var colors = {
  info: 'foreground.secondary',
  error: 'foreground.destructive'
};
export default function Message(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'info' : _ref$type,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Text, {
    variant: "birch",
    color: colors[type],
    "data-test": "".concat(type, "-message")
  }, children);
}
Message.propTypes = {
  /** The type of the message, indicating its coloring */
  type: PropTypes.oneOf(['info', 'error']),
  /** The actual message */
  children: PropTypes.node
};